const DeviceSettingsTab = ({ afrDevices, onEditDevices }) => {
    const devices = afrDevices || [];

    return (
        <div className="pp-section">
            <div className="pp-section__header">
                <h3 className="pp-section__title">
                    Accept Finish Reason Devices
                    <span className="pp-section__count">({devices.length})</span>
                </h3>
                <div className="pp-section__actions">
                    <button className="dp-btn dp-btn--primary dp-btn--sm" onClick={onEditDevices}>
                        <i className="fe fe-edit" style={{ fontSize: '13px' }} />
                        Add / Remove
                    </button>
                </div>
            </div>
            {devices.length > 0 ? (
                <div className="pp-section__body--flush">
                    <div className="ss-device-list">
                        {devices.map((device, i) => (
                            <div key={`dev-${i}`} className="ss-device-list__item">
                                {device}
                            </div>
                        ))}
                    </div>
                </div>
            ) : (
                <div className="pp-section__body">
                    <div className="ss-empty">
                        <p className="ss-empty__text">
                            No AFR devices configured. Click "Add / Remove" to select devices.
                        </p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DeviceSettingsTab;
